<script>
    import broker from '../../utils/broker'

    import BeritaSidebar from '@/components/sections/berita-sidebar';
    import BeritaDetailContent from '@/components/berita-detail-content';
    export default {
        components: {
            BeritaSidebar,
            BeritaDetailContent
        },
        data () {
            return {
                newsDetail : {}
            }
        },
        mounted(){
            let url = this.$route.query.id
            broker.fetch.get(`/webschool/content/${url}`)
            .then(res => {
                this.newsDetail = res.data.data

            });
        }
    };
</script>
<template>
    <div class="page-wrapper section-space--inner--60">
        <div class="blog-section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row blog-details">
                            <BeritaDetailContent :beritaDetail="newsDetail" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

